export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  authorTitle: string;
  readCount: number;
  commentCount: number;
  publishDate: string;
  imageUrl: string;
  imageWidth: number;
  imageHeight: number;
  isHot: boolean;
  isExclusive: boolean;
  tags: string[];
  content?: string;
  quoteHighlight?: string;
}

export const articles: Article[] = [
  {
    id: "1",
    title: "某顶流男星深夜密会神秘女子，酒店同住三天三夜全程被拍",
    excerpt: "据知情人士透露，该男星与神秘女子在某五星级酒店连续同住三天，期间多次被目击同进同出，举止亲密。",
    category: "网红大瓜",
    categorySlug: "wanghong-dagua",
    author: "吃瓜前线",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20male%20reporter%20avatar%20portrait%20with%20warm%20lighting%20on%20neutral%20background%2C%20professional%20casual%20style%2C%20friendly%20expression&width=120&height=120&seq=author-01&orientation=squarish",
    authorTitle: "首席爆料记者",
    readCount: 128900,
    commentCount: 3456,
    publishDate: "2026-06-30",
    imageUrl: "https://readdy.ai/api/search-image?query=dark%20moody%20hotel%20corridor%20at%20night%20with%20warm%20ambient%20lighting%2C%20luxury%20atmosphere%2C%20mysterious%20vibe%2C%20cinematic%20composition%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%20style%20with%20warm%20golden%20tones%20and%20deep%20shadows&width=800&height=500&seq=article-01&orientation=landscape",
    imageWidth: 800,
    imageHeight: 500,
    isHot: true,
    isExclusive: true,
    tags: ["顶流男星", "密会", "酒店", "独家爆料"],
    quoteHighlight: "这个圈子从来都不缺故事，缺的是敢于说出真相的人。我们不是在八卦，我们是在还原娱乐圈最真实的生态。",
    content: "据多方消息源证实，这位近期热度极高的男星，在过去一周内确实与一名非娱乐圈女性保持密切接触。目击者称两人在某高端酒店大堂相遇后，便一同进入电梯前往客房楼层...\n\n更令人惊讶的是，这位男星近期刚在公开场合表态自己是单身状态，这一爆料无疑将引发粉丝群体的强烈反应...\n\n业内人士分析，若此事属实，该男星代言的多个品牌可能面临解约风险，损失或达数千万。"
  },
  {
    id: "2",
    title: "某女团成员私密聊天记录曝光，涉及队友关系及公司内幕",
    excerpt: "一组涉及多位当红女团成员的私密聊天截图在网上疯传，内容劲爆引发全网热议。",
    category: "黑料爆料",
    categorySlug: "heiliao-baoliao",
    author: "深度爆料组",
    authorAvatar: "https://readdy.ai/api/search-image?query=female%20Chinese%20journalist%20avatar%20portrait%20with%20soft%20lighting%2C%20professional%20look%2C%20neutral%20expression%2C%20clean%20composition&width=120&height=120&seq=author-02&orientation=squarish",
    authorTitle: "调查记者",
    readCount: 256700,
    commentCount: 7821,
    publishDate: "2026-06-29",
    imageUrl: "https://readdy.ai/api/search-image?query=dark%20smartphone%20screen%20displaying%20chat%20messages%20in%20dim%20lighting%2C%20mysterious%20atmosphere%2C%20dramatic%20shadows%2C%20editorial%20photography%2C%20warm%20accent%20lighting%2C%20cinematic%20mood&width=800&height=500&seq=article-02&orientation=landscape",
    imageWidth: 800,
    imageHeight: 500,
    isHot: true,
    isExclusive: true,
    tags: ["女团", "聊天记录", "内幕", "队友关系"],
    quoteHighlight: "光鲜亮丽的舞台背后，明星也是普通人。但有些真相，比电视剧还要精彩一百倍。",
    content: "昨日深夜，一组据称来自某知名女团内部群聊的截图突然在各大平台传播。截图中涉及的内容包括成员之间的矛盾、对经纪公司的不满、以及某些未公开的商业安排细节...\n\n目前该女团所属经纪公司已发布声明，称将追究泄露者的法律责任..."
  },
  {
    id: "3",
    title: "知名导演新片片场突发事故，多名演员受伤送医",
    excerpt: "某一线导演执导的大制作电影在拍摄期间发生意外，特效装置失控导致多人受伤。",
    category: "每日大赛",
    categorySlug: "meiri-dasai",
    author: "影视速递",
    authorAvatar: "https://readdy.ai/api/search-image?query=young%20Chinese%20male%20reporter%20avatar%20portrait%2C%20warm%20lighting%2C%20professional%20casual%20style%2C%20confident%20expression&width=120&height=120&seq=author-03&orientation=squarish",
    authorTitle: "影视线记者",
    readCount: 89100,
    commentCount: 2103,
    publishDate: "2026-06-28",
    imageUrl: "https://readdy.ai/api/search-image?query=film%20set%20with%20emergency%20situation%2C%20dark%20atmosphere%2C%20scattered%20equipment%2C%20dramatic%20lighting%2C%20behind%20the%20scenes%20movie%20production%2C%20editorial%20style%20with%20warm%20tones%20and%20deep%20shadows&width=800&height=500&seq=article-03&orientation=landscape",
    imageWidth: 800,
    imageHeight: 500,
    isHot: true,
    isExclusive: false,
    tags: ["导演", "片场事故", "受伤", "电影"],
    quoteHighlight: "安全永远是第一位的。再宏大的制作，如果连最基本的防护都做不到位，那就是在拿生命开玩笑。",
    content: "今日下午，某知名导演执导的年度大制作在拍摄一组动作戏份时，特效烟火装置突发故障发生爆炸...\n\n现场三名演员和两名工作人员被紧急送往附近医院，所幸暂无生命危险..."
  },
  {
    id: "4",
    title: "某综艺节目录制现场爆发激烈冲突，导演组紧急叫停",
    excerpt: "因游戏环节争议，两位常驻嘉宾在现场发生口角，情绪失控导致录制中断。",
    category: "每日大赛",
    categorySlug: "meiri-dasai",
    author: "综艺扒姐",
    authorAvatar: "https://readdy.ai/api/search-image?query=female%20Chinese%20entertainment%20reporter%20avatar%2C%20warm%20portrait%20lighting%2C%20friendly%20smile%2C%20professional%20headshot%20style&width=120&height=120&seq=author-04&orientation=squarish",
    authorTitle: "综艺分析师",
    readCount: 145300,
    commentCount: 4520,
    publishDate: "2026-06-28",
    imageUrl: "https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20tense%20atmosphere%2C%20dramatic%20lighting%2C%20reality%20show%20production%2C%20behind%20the%20scenes%20chaos%2C%20editorial%20photography%20warm%20tones%20dark%20mood&width=800&height=500&seq=article-04&orientation=landscape",
    imageWidth: 800,
    imageHeight: 500,
    isHot: false,
    isExclusive: false,
    tags: ["综艺", "冲突", "嘉宾", "录制中断"],
    content: "据现场工作人员透露，冲突起因是游戏环节中一位嘉宾认为另一位故意犯规..."
  },
  {
    id: "5",
    title: "某一线女星被拍到深夜出入整形医院，工作室火速辟谣",
    excerpt: "网友偶遇某女星深夜从知名医美机构后门离开，全程口罩墨镜严密遮挡。",
    category: "网红大瓜",
    categorySlug: "wanghong-dagua",
    author: "娱乐显微镜",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20male%20entertainment%20journalist%20avatar%2C%20professional%20portrait%2C%20neutral%20background%2C%20warm%20lighting%2C%20serious%20expression&width=120&height=120&seq=author-05&orientation=squarish",
    authorTitle: "高级娱乐记者",
    readCount: 198400,
    commentCount: 6120,
    publishDate: "2026-06-27",
    imageUrl: "https://readdy.ai/api/search-image?query=dark%20alley%20behind%20medical%20building%20at%20night%2C%20mysterious%20figure%20in%20shadow%2C%20warm%20street%20light%2C%20editorial%20style%20photography%2C%20dramatic%20contrast%20with%20golden%20and%20dark%20tones&width=800&height=500&seq=article-05&orientation=landscape",
    imageWidth: 800,
    imageHeight: 500,
    isHot: true,
    isExclusive: true,
    tags: ["女星", "整形", "辟谣", "偷拍"],
    content: "昨晚十一点左右，有网友拍到某当红女星从某知名医美机构后门离开..."
  },
  {
    id: "6",
    title: "某电竞主播涉嫌赌博被警方带走，直播间被封停",
    excerpt: "知名游戏主播在直播中涉嫌引导粉丝参与网络赌博，已被有关部门介入调查。",
    category: "黑料爆料",
    categorySlug: "heiliao-baoliao",
    author: "游戏早知道",
    authorAvatar: "https://readdy.ai/api/search-image?query=young%20male%20gaming%20reporter%20avatar%2C%20portrait%20with%20cool%20tone%2C%20professional%20look%2C%20neutral%20background&width=120&height=120&seq=author-06&orientation=squarish",
    authorTitle: "电竞线记者",
    readCount: 312000,
    commentCount: 9820,
    publishDate: "2026-06-26",
    imageUrl: "https://readdy.ai/api/search-image?query=dark%20gaming%20streaming%20setup%20with%20red%20warning%20lighting%2C%20dramatic%20atmosphere%2C%20computer%20screen%20showing%20banned%20message%2C%20editorial%20photography%20with%20warm%20dark%20tones&width=800&height=500&seq=article-06&orientation=landscape",
    imageWidth: 800,
    imageHeight: 500,
    isHot: true,
    isExclusive: false,
    tags: ["电竞", "赌博", "警方", "封停"],
    content: "昨日，某知名游戏直播平台头部主播在直播中被警方带走..."
  },
  {
    id: "7",
    title: "某选秀节目冠军被爆学历造假，粉丝后援会集体脱粉",
    excerpt: "此前一直以名校学霸人设示人的选秀冠军，被网友扒出学历信息存在严重不实。",
    category: "网红大瓜",
    categorySlug: "wanghong-dagua",
    author: "吃瓜前线",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20male%20reporter%20avatar%20portrait%20with%20warm%20lighting%20on%20neutral%20background%2C%20professional%20casual%20style%2C%20friendly%20expression&width=120&height=120&seq=author-01&orientation=squarish",
    authorTitle: "首席爆料记者",
    readCount: 275000,
    commentCount: 8450,
    publishDate: "2026-06-25",
    imageUrl: "https://readdy.ai/api/search-image?query=ceremony%20stage%20with%20crown%20and%20confetti%20but%20dark%20moody%20atmosphere%2C%20dramatic%20lighting%2C%20contrast%20between%20celebration%20and%20shadow%2C%20editorial%20photography%20warm%20golden%20dark%20tones&width=800&height=500&seq=article-07&orientation=landscape",
    imageWidth: 800,
    imageHeight: 500,
    isHot: false,
    isExclusive: false,
    tags: ["选秀", "学历造假", "脱粉", "人设崩塌"],
    content: "近日，有网友发现某选秀节目冠军的学历信息存在多处矛盾..."
  },
  {
    id: "8",
    title: "某知名演员被曝婚内出轨多年，原配忍无可忍提出离婚",
    excerpt: "一段据称是该演员与第三者的亲密视频在社交平台疯传，原配已委托律师启动离婚程序。",
    category: "黑料爆料",
    categorySlug: "heiliao-baoliao",
    author: "深度爆料组",
    authorAvatar: "https://readdy.ai/api/search-image?query=female%20Chinese%20journalist%20avatar%20portrait%20with%20soft%20lighting%2C%20professional%20look%2C%20neutral%20expression%2C%20clean%20composition&width=120&height=120&seq=author-02&orientation=squarish",
    authorTitle: "调查记者",
    readCount: 456000,
    commentCount: 15230,
    publishDate: "2026-06-24",
    imageUrl: "https://readdy.ai/api/search-image?query=luxury%20apartment%20interior%20at%20night%20with%20dramatic%20shadow%20play%2C%20mysterious%20and%20tense%20atmosphere%2C%20editorial%20photography%2C%20warm%20golden%20lighting%20with%20deep%20dark%20contrasts&width=800&height=500&seq=article-08&orientation=landscape",
    imageWidth: 800,
    imageHeight: 500,
    isHot: true,
    isExclusive: true,
    tags: ["出轨", "离婚", "演员", "已婚"],
    content: "娱乐圈又一起婚姻危机被曝光..."
  },
  {
    id: "9",
    title: "某网红带货翻车，所售产品被检出致癌物超标",
    excerpt: "拥有千万粉丝的带货主播推荐的美妆产品，经第三方检测发现含有禁用的致癌成分。",
    category: "每日大赛",
    categorySlug: "meiri-dasai",
    author: "消费警示员",
    authorAvatar: "https://readdy.ai/api/search-image?query=female%20Chinese%20consumer%20reporter%20avatar%2C%20serious%20expression%2C%20professional%20portrait%2C%20warm%20lighting%2C%20clean%20background&width=120&height=120&seq=author-09&orientation=squarish",
    authorTitle: "消费维权记者",
    readCount: 198000,
    commentCount: 5670,
    publishDate: "2026-06-23",
    imageUrl: "https://readdy.ai/api/search-image?query=skincare%20products%20on%20table%20with%20warning%20labels%2C%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20editorial%20product%20photography%2C%20warm%20golden%20and%20dark%20tones&width=800&height=500&seq=article-09&orientation=landscape",
    imageWidth: 800,
    imageHeight: 500,
    isHot: false,
    isExclusive: false,
    tags: ["网红", "带货翻车", "致癌物", "美妆"],
    content: "近日，第三方检测机构对某千万粉丝网红推荐的热销美妆产品进行了检测..."
  }
];

export const articlesByCategory: Record<string, Article[]> = {
  "wanghong-dagua": articles.filter(a => a.categorySlug === "wanghong-dagua"),
  "heiliao-baoliao": articles.filter(a => a.categorySlug === "heiliao-baoliao"),
  "meiri-dasai": articles.filter(a => a.categorySlug === "meiri-dasai"),
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find(a => a.id === id);
};